<template>
    <div id="appReloadMessage" class="AppReloadMessage">
        <div class="shortMessage">
            {{ $t('messageShort') }}
        </div>
        <div class="longMessage">
            {{ $t('message') }}
        </div>
        <div class="button --global-clickable" @click="reload()">
            {{ $t('button') }}
        </div>
    </div>
</template>

<translations>
  message: 'New version of Memolife available'
  message_no: 'Ny version av Memolife tilgjengelig'
  messageShort: 'New version available'
  messageShort_no: 'Ny version tilgjengelig'
  button: 'Update Now'
  button_no: 'Oppdater nå'
</translations>

<script>
export default {
    methods: {
        reload() {
            location.reload();
        }
    }
};
</script>

<style scoped lang="scss">
.AppReloadMessage {
    flex: none;
    display: flex;
    align-items: center;
    padding: 0.5em 2em;
    color: rgba(black, 0.8);
}
.button {
    background-color: $standardButtonColor;
    color: white;
    border-radius: 0.3em;
    padding: 0.3em 0.8em;
    margin-left: 1em;
}
.shortMessage {
    display: none;
}

@include media('<mobile') {
    .AppReloadMessage {
        padding: 0.5em 1em;
        justify-content: space-between;
    }

    .longMessage {
        display: none;
    }
    .shortMessage {
        display: block;
    }
}
</style>
